import { HttpHelper, HttpServiceParams } from 'rbh-merchant-core';
import { USER_REQUEST_ID_LIST } from './user-constant';
import { envConfig } from '../../../../config';

class UserServiceClass {
  private url = envConfig.hostname + 'v1/merchant/company-admin/users';

  getUser = async () => {
    return await HttpHelper.get({
      url: this.url,
      id: USER_REQUEST_ID_LIST.GET_USER
    });
  }

  addUser = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: this.url,
      data: params.data,
      id: USER_REQUEST_ID_LIST.ADD_USER
    });
  }

  deleteUser = async (params: HttpServiceParams) => {
    return await HttpHelper.delete({
      url: this.url,
      config: {
        headers: {
          merchantUserId: params.data
        }
      },
      id: USER_REQUEST_ID_LIST.DELETE_USER
    });
  }

  editUser = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: this.url,
      data: params.data,
      id: USER_REQUEST_ID_LIST.EDIT_USER
    });
  }
}

export const UserService = new UserServiceClass();
